/* RN brand v5: marks the page as scripted. Scroll reveals were removed on purpose so nothing hides or covers text. */
document.documentElement.classList.add('rn-js');
